import { RootState } from "@/store/store";
import { activeProviderConnectionSelector } from "@/store/provider-connections/selectors/active-connection/activeProviderConnectionSelector";
import { ProviderConnection } from "@/components/pages/integrations/components/common/types/common";

export const activeProviderConnectionTypeSelector = (
  state: RootState,
): ProviderConnection | null => {
  return activeProviderConnectionSelector(state).type;
};
